// src/utils/axios.js
import axios from "axios";
import { showSnackbar } from "src/utils/SnackbarUtils";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong";

    showSnackbar(message, "error");

    if (status === 401 || message.toLowerCase().includes("unauthorized")) {
      sessionStorage.removeItem("authToken");
      sessionStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

const AxiosClient = async ({
  method = "get",
  url,
  data,
  params,
  headers = {},
  toolkit,
}) => {
  try {
    const response = await axiosInstance({
      method,
      url,
      data,
      params,
      headers,
    });

    return response.data;
  } catch (error) {
    if (toolkit?.rejectWithValue) {
      return toolkit.rejectWithValue(
        error?.response?.data || { message: "Unexpected error" }
      );
    }
    throw error;
  }
};

export default AxiosClient;
